define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/widget/ErrorText",
	"csi/xml"
], function(declare, lang, def, Action, Field, Relationship, ViewRef, Widget, ErrorText, xml) {

	const FAILED_ORDERS = "FailedOrders";
	const FAILED_SHIPMENTS = "FailedShipments";
	const FI_ORDERS = "FIOrders";
	const FI_SHIPMENTS = "FIShipments";
	const ORDER = "Order";
	const ORDERS = "Orders";
	const PARTIAL_PASS_COMMENT = "PartialPassComment";
	const SHIPMENT = "Shipment";
	const SHIPMENTS = "Shipments";

	const _NoOrdersMessageText = declare(ErrorText, {
		infoResource: "NoFinalInspectionOrders_PartialPassForm"
	});

	const _NoShipmentsMessageText = declare(ErrorText, {
		infoResource: "NoFinalInspectionShipments_PartialPassForm"
	});
	
	return declare(Widget, {

		/** @property {string} batchString - "Batch" for Batch Level, "" for Inspection Level */
		batchString: "",

		/**
		 * @override
		 * Add order or shipment fields depending on InspectionType
		 */
		_resolveView : function() {

			if (this.batchString) {
				const parentInspection = this.defView.getSource().getParent();
				const batchNode = this.cacheView.getNode(this.urlRoot);
				this.addDefaultValue(PARTIAL_PASS_COMMENT, batchNode.PartialPassComment);
				const parentURL = xml.nodeGetURL(parentInspection);
				const parentInspectionType = xml.enumGetText(parentInspection.InspectionType);
				const hasOrders = parentInspection.FIOrders && parentInspection.FIOrders.length;
				const hasShipments = parentInspection.FIShipments && parentInspection.FIShipments.length;
				switch(parentInspectionType) {
					case ORDER: {
						const field = lang.mixin(new Field(), {
							idParameter: FAILED_ORDERS,
							m_label: FAILED_ORDERS,
							m_relationship: lang.mixin(new Relationship(), {
								m_id: FI_ORDERS,
								m_url: parentURL,
							}),
							m_typeControl: def.FIELD_MULTI_SELECT,
						});
						if (!hasOrders) {
							this.setFieldDisabled(field, true);
							field.messageClass = _NoOrdersMessageText;
						} else {
							this.addDefaultValue(field.m_label, batchNode.FailedOrders);
						}
						this.insertField(field);
						break;
					}
					case SHIPMENT: {
						const field = lang.mixin(new Field(), {
							idParameter: FAILED_SHIPMENTS,
							m_label: FAILED_SHIPMENTS,
							m_relationship: lang.mixin(new Relationship(), {
								m_id: FI_SHIPMENTS,
								m_url: parentURL,
							}),
							m_typeControl: def.FIELD_MULTI_SELECT,
						});
						if (!hasShipments) {
							this.setFieldDisabled(field, true);
							field.messageClass = _NoShipmentsMessageText;
						} else {
							this.addDefaultValue(field.m_label, batchNode.FailedShipments);
						}
						this.insertField(field);
						break;
					}
				}
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Add Go to Dialog to Failed Orders and Failed Shipments form
		 */
		getFieldStore: function(field, value) {
			const store = this.inherited(arguments);
			const parentInspectionURL = this.defView.getSource().m_urlParent;
			switch (field.getControlName()) {
				case FAILED_ORDERS: {
					store.action = lang.mixin(new Action(), {
						m_viewRef: lang.mixin(new ViewRef(), {
							m_id: ORDERS,
							m_url: parentInspectionURL,
						})
					});
					break;
				}
				case FAILED_SHIPMENTS: {
					store.action = lang.mixin(new Action(), {
						m_viewRef: lang.mixin(new ViewRef(), {
							m_id: SHIPMENTS,
							m_url: parentInspectionURL,
						})
					});
					break;
				}
			}

			return store;
		}
	});
});